// @flow
import _ from 'lodash';

const jqXhrKeys = [
  'readyState',
  'getResponseHeader',
  'getAllResponseHeaders',
  'setRequestHeader',
  'overrideMimeType',
  'statusCode',
  'abort',
  'state',
  'always',
  'catch',
  'pipe',
  'then',
  'promise',
  'progress',
  'done',
  'fail',
  'responseJSON',
  'status',
  'statusText'
];

export function isJqXhr(o: Object) {
  if (typeof o !== 'object') {
    return false;
  }

  const keys = Object.keys(o);
  return _.isEqual(keys.sort(), jqXhrKeys.sort());
}
